function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3332 8V14.6667H2.6665V8",
  stroke: "#CACED2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6668 4.66666H1.3335V8H14.6668V4.66666Z",
  stroke: "#CACED2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14.6667V4.66666",
  stroke: "#CACED2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00016 4.66667H5.00016C4.55814 4.66667 4.13421 4.49107 3.82165 4.17851C3.50909 3.86595 3.3335 3.44203 3.3335 3C3.3335 2.55797 3.50909 2.13405 3.82165 1.82149C4.13421 1.50893 4.55814 1.33334 5.00016 1.33334C7.3335 1.33334 8.00016 4.66667 8.00016 4.66667Z",
  stroke: "#CACED2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.66667H11C11.442 4.66667 11.866 4.49107 12.1785 4.17851C12.4911 3.86595 12.6667 3.44203 12.6667 3C12.6667 2.55797 12.4911 2.13405 12.1785 1.82149C11.866 1.50893 11.442 1.33334 11 1.33334C8.66667 1.33334 8 4.66667 8 4.66667Z",
  stroke: "#CACED2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgGift = function SvgGift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift.a9558263.svg";
export { ForwardRef as ReactComponent };